import { ResultMetric } from '../types';

export interface CharacterProfileCopy {
  subtitle: string;
  categoryBadge: string;
  badgeType: 'normal' | 'danger';
  systemVerdict: string;
  detailedAnalysis: [string, string, string];
  metrics: ResultMetric[];
  stampText: string;
  stampType: 'normal' | 'danger';
  coexistenceAdvice: string;
  confidentialLevel: string;
}

export const CHARACTER_PROFILES: Record<string, CharacterProfileCopy> = {
  // ==================== 现实宠物池 (23 种) ====================

  golden_retriever: {
    subtitle: '全天候高照度阳光情绪泵 · 秩序自律型伴侣',
    categoryBadge: '【合格：标准碳基优秀伴侣】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：恭喜你，你的作息曲线与精神健全度奇迹般地抵御住了测试后半段的全部降智诱导。你拥有极其罕见的社会化自律能力、规律的物理运动习惯，以及对真实生命沉甸甸的托底耐心。\n\n金毛寻回犬是经过系统 35 维全量变量矩阵测算后，与你现实生活方式契合度最高的最佳伴侣。它毫无保留的信任和每一次下班开门时的摇尾飞扑，将成为你现实生活最稳固的情绪锚点。',
    detailedAnalysis: [
      '1. 规律作息强行咬合：你具备接纳大体型生命与高频次毛发清洁的胸怀。它每天早晚雷打不动的运动需求，对你而言并非消耗负担，而是将你从封闭室内强行拽入清晨阳光与晚风中的救赎契机。',
      '2. 纯粹而长久的情感反馈：它是一台全天候无休的“开心制造机”。哪怕你在外面被老板骂成筛子、被客户折磨到怀疑人生，只要推开家门，在它眼里你依然是整个宇宙的神。',
      '3. 成熟契约自洽：你拥有将一段长达十余年生命契约善始善终的成熟心智。你们的共处将成为文明人类与忠诚生灵之间最典范的生活诗篇。',
    ],
    metrics: [
      { label: '作息规律度', value: 92, note: '稳定而健康的生活时钟', isWarning: false },
      { label: '户外运动承载力', value: 94, note: '体能充沛，乐于奔跑', isWarning: false },
      { label: '现实自理与责任感', value: 95, note: '高度靠谱的托底主体', isWarning: false },
      { label: '抗内耗钝感力', value: 88, note: '阳光气场驱散焦虑', isWarning: false },
    ],
    stampText: '【合规准养 · 正式批复】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：请提前备好强力吸尘器与结实飞盘；每天至少给予它 45 分钟的草坪狂奔时间，它将回馈你一整个充满金黄暖意的宇宙。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 可堂堂正正发朋友圈',
  },

  border_collie: {
    subtitle: '超高智商敏捷博弈合伙人 · 活力永动机',
    categoryBadge: '【合格：高敏捷智慧生命】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：测试数据显示，你的精力储备与智力带宽远超同龄平均值。你不满足于低智的单向服从，反而渴望在日常生活里拥有一位能与你棋逢对手、甚至偶尔在智商上鄙视你的非人类合伙人。\n\n边境牧羊犬是全宇宙智商最接近人类的犬种。选择它，意味着你签署了一份长达十五年的“每日脑力拉力赛”契约——你不遛它，它就会在客厅制定逃狱计划并当着你的面开防盗门。',
    detailedAnalysis: [
      '1. 双向智商碾压与尊重：普通狗以为你丢飞盘是在玩，边牧以为你笨到每次都拿不住飞盘。它能听懂你复杂的指令甚至你的微表情，这种高阶沟通将极大满足你的精神互动渴望。',
      '2. 庞大动能的高效消耗：你身上有一股不服输的行动力。每天带着它高强度飞盘、敏捷障碍训练，能将你工作中积攒的神经内耗转化为纯粹的肉体多巴胺。',
      '3. 互相训导的生活羁绊：你俩的相处不是传统意义上的“主仆”，而是两个聪明生物的联合执政。你会发现它在潜移默化中纠正你的拖延症，甚至监督你的晨跑打卡。',
    ],
    metrics: [
      { label: '智力博弈匹配度', value: 98, note: '脑力交锋互不相让', isWarning: false },
      { label: '体能消耗上限', value: 96, note: '永动级户外狂奔需求', isWarning: false },
      { label: '复杂指令理解力', value: 95, note: '眼神交流即知进退', isWarning: false },
      { label: '反骨防脱轨警戒', value: 42, note: '需谨防它反向驯化你', isWarning: true },
    ],
    stampText: '【特许准养 · 需高智认证】',
    stampType: 'normal',
    coexistenceAdvice:
      '⚠️ 饲养警示：每天出门前请先解开两道奥数题向它报备；严禁当着它的面藏零食，因为它的记忆力可能比你期末背题库还精准。',
    confidentialLevel: 'CL-2 进阶级伙伴档案 · 适合高能精英人类',
  },

  alaskan_malamute: {
    subtitle: '大体量憨厚温热巨兽 · 漫天飞雪型陪伴',
    categoryBadge: '【合格：极地重型犬类】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你对“安全感”的定义极度具象化——它必须足够大、足够沉、毛发足够厚实。你的心胸宽广如西伯利亚平原，对于家里的沙发多几根浮毛或偶尔被撞翻一个水杯有着超乎常人的包容度。\n\n阿拉斯加雪橇犬是行走的移动暖炉与重装毛球。它体型庞大却内心如同幼童，只要往你身边一趴，整座屋子的空虚感都会被它巨大的体积彻底填满。',
    detailedAnalysis: [
      '1. 物理层面的绝对庇护感：七八十斤的纯实木身躯往玄关一坐，任何孤单与不安全感都会瞬间灰飞烟灭。冬天窝在沙发上，它可以充当一整张会呼吸的恒温毛毯。',
      '2. 憨厚直率的情绪宣泄：它没有小狗的娇气与弯弯绕，高兴了就发出狼嚎般的粗犷吼声，委屈了就拿大熊掌扒拉你。这种毫无保留的大颗粒情感，能直接治愈你的精神枯竭。',
      '3. 空间与体能的宏大融合：你需要一个足够大的物理舞台，也拥有一副能经得住“大狗飞扑”的强健体魄。带它出门回头率百分之百，那是属于巨犬饲养者的绝对排面。',
    ],
    metrics: [
      { label: '物理安全感满载', value: 99, note: '吨位级踏实体魄', isWarning: false },
      { label: '毛发风暴耐受力', value: 94, note: '家里常年落大雪', isWarning: false },
      { label: '大体格包容度', value: 92, note: '抗冲撞抗造能力强', isWarning: false },
      { label: '牵引绳反向拔河', value: 85, note: '溜它等于免费练深蹲', isWarning: false },
    ],
    stampText: '【重装核准 · 空间合格】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：请购置工业级吹水机；夏天务必保证 24 小时恒温冷气；下楼散步时请穿防滑运动鞋，谨防被它当成雪橇拖拽起飞。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 霸气威风型',
  },

  shiba_inu: {
    subtitle: '高自洽傲娇界限观察员 · 猫性固执犬类',
    categoryBadge: '【合格：高独立性犬类】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你身上带有一种非常清醒的现代人社交防御机制——表面礼貌客气，甚至能随时营业露出标准假笑，但内心深处极度看重“私人界限”。你反感毫无分寸的过度黏腻，更欣赏彼此自洽、互不绑架的松弛关系。\n\n柴犬是犬界里最具“猫性”的神奇存在。它爱干净、不乱叫、极度倔强，下雨天只要它不想走，全身每根骨头都会变成定海神针。你们两个的灵魂在“嘴硬心软”和“保持边界”上达到了完美的同频。',
    detailedAnalysis: [
      '1. 彼此尊重的安全礼貌车距：它不会像一般舔狗那样无脑蹭你。它更喜欢坐在离你两米远的单人沙发上，一边揣着手一边斜眼观察你。这种“你在，我安心，但别烦我”的距离感，恰好是你最舒服的社交舒适区。',
      '2. 傲娇背后的深层信赖：让一只柴犬对你摇尾巴可能需要三个月，但一旦它认定你，它的飞机耳和假笑就会只为你一人绽放。这种通过时间沉淀换来的认可，比廉价的热情珍贵一万倍。',
      '3. 互相较劲的幽默日常：它性格固执，你脾气也不小。每次出门散步拉扯回家的博弈，都会成为生活里最解压的幽默情景剧。',
    ],
    metrics: [
      { label: '边界感分寸契合', value: 96, note: '各自安好互不打扰', isWarning: false },
      { label: '倔强指数同频', value: 92, note: '拉不动的定海神针', isWarning: false },
      { label: '营业假笑解码力', value: 90, note: '看破彼此社交伪装', isWarning: false },
      { label: '洁癖与自理默契', value: 88, note: '像猫一样爱惜羽毛', isWarning: false },
    ],
    stampText: '【自洽核准 · 彼此尊重】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：出门请务必换装防挣脱胸背带；遇到它当街摆烂耍赖拒绝移动时，建议不要硬拽，掏出肉干进行体面外交。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 帅气有性格',
  },

  pomeranian: {
    subtitle: '微型高频情绪播报机 · 掌上恃宠生骄精',
    categoryBadge: '【合格：高存在感伴侣犬】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你的生活里需要一些高密度的娇气、明亮的声音和毫无保留的热闹。你可能在现实中习惯了扮演情绪稳定的成年人，但在私密空间里，你极度渴望被一个毛茸茸、轻飘飘的小生命肆无忌惮地撒娇与依赖。\n\n博美犬是一团长了眼睛的白色棉花糖，体重三斤，心气八百斤。它把你当成全世界唯一的靠山，走到哪都哒哒哒踩着小碎步跟到哪。有它在，你的家将永远告别冷清。',
    detailedAnalysis: [
      '1. 爆棚的情感代偿与被需要感：当你累瘫在床边，它会像个小毛球一样蹦蹦跳跳扒你裤脚，眼巴巴求抱抱。抱进怀里那一刻，你身上所有的成年人防线都会被它的软萌彻底卸载。',
      '2. 掌心级空间与便携性：无需大豪宅，它甚至可以在一个开间里开心地自转八十圈。出门装进斜挎包就能带走，是城市独居青年最灵活的掌中宝。',
      '3. 傲娇小脾气的幽默调剂：虽然长得像洋娃娃，但脾气像个小炮仗，看门护主比大狗还卖力。看着它对着空气龇牙奶叫，你会忍不住笑出声来。',
    ],
    metrics: [
      { label: '情感黏度需求', value: 97, note: '高浓度贴贴狂魔', isWarning: false },
      { label: '轻量化空间适应', value: 95, note: '小户型甚至合租极度友好', isWarning: false },
      { label: '声学热闹耐受度', value: 82, note: '清脆吠叫当生活背景音', isWarning: false },
      { label: '颜值暴击治愈力', value: 99, note: '萌就是最高生产力', isWarning: false },
    ],
    stampText: '【萌系核准 · 全力宠溺】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：注意保护其娇嫩的膝关节，避免频繁上下高沙发；每天请花十分钟轻柔梳理其丰盈被毛，它将成为你随身携带的治愈小天使。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 极度上镜可爱',
  },

  french_bulldog: {
    subtitle: '低耗能沙发共存重装体 · 物理级呼噜发射源',
    categoryBadge: '【合格：低运动量耐受型】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你是一位务实且充满松弛感的生活哲学家。你厌恶一切虚头巴脑的过度包装，也拒绝逼迫自己去执行虚伪的“每天户外狂跑十公里”。你享受下班后往沙发上一陷、喝口冰可乐的平凡幸福。\n\n法斗犬是犬界当之无愧的“躺平代言人”。它不拆家、不狂吠、耐力极差，走两百米就气喘吁吁要求打道回府。你们两个往客厅地毯上一躺，彼此打呼噜的节奏都能对得上号。',
    detailedAnalysis: [
      '1. 极低运动消耗负罪感：你完全不用担心“今天没遛够它会不会抑郁”，它比你更想早点回家吹空调。这种零运动压力的共处模式，对社畜而言简直是恩赐。',
      '2. 丑萌外表下的温顺灵魂：满脸褶子、小猪鼻子、圆滚滚的身材。它虽然看起来像个黑帮小保镖，实则脾气好到哪怕你捏它脸蛋半小时它也只是懒洋洋打个哈欠。',
      '3. 沉浸式陪伴白噪音：它的呼吸声和轻微小呼噜，在安静的深夜能形成一种极其奇妙的催眠白噪音，带给你莫大的安心与踏实感。',
    ],
    metrics: [
      { label: '低能耗作息咬合', value: 98, note: '能躺绝不坐，能坐绝不站', isWarning: false },
      { label: '宅家舒适度满分', value: 95, note: '沙发即宇宙中心', isWarning: false },
      { label: '情绪稳定与抗造', value: 90, note: '极难激怒的憨厚胖墩', isWarning: false },
      { label: '户外暴晒耐受度', value: 15, note: '极度怕热，需空调保命', isWarning: true },
    ],
    stampText: '【松弛核准 · 宅家挚友】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：夏天严禁正午出门，谨防短鼻呼吸道中暑；定期用湿巾清理脸部面褶；给它准备一个厚实的记忆棉狗窝，它会睡得像一头满足的小猪。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 丑萌治愈派',
  },

  ragdoll_cat: {
    subtitle: '高容忍度仙女软体生灵 · 纯糖度移动地毯',
    categoryBadge: '【合格：高亲和性仙女猫】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你的审美体系里驻扎着对“温柔、优雅与高纯度治愈”的执念。你善解人意，愿意为了美好的事物投入耐心，甚至不惜在工作之余花半小时安安静静地做一件细致的手工或清洁。\n\n布偶猫被称为“小狗猫”和“行走的水晶糖”。它拥有一双摄人心魄的蓝色星空眼，抱在怀里像一滩彻底融化的温热棉花糖，任你揉搓亲吻，永远不伸爪子。它是你疲惫生活中最梦幻的一场温柔乡。',
    detailedAnalysis: [
      '1. 极致触觉抚慰：当你用指尖划过它丝缎般厚密的被毛，耳边响起低沉的咕噜咕噜震动声，外部世界所有的戾气与浮躁都会在瞬间被它吸收殆尽。',
      '2. 无攻击性的绝对温顺：它对人类的容忍度高到惊人，没有传统猫科动物的神经质与阴晴不定。无论你何时呼唤它，它都会迈着小碎步软绵绵朝你走来，把脑袋拱进你的手心。',
      '3. 双向治愈的仪式感：每天下班给它梳毛、看它在阳光下伸懒腰，将成为你生活中最纯净、最具有仪式感的心灵冥想时刻。',
    ],
    metrics: [
      { label: '治愈甜度超标', value: 99, note: '毫无攻击性的纯粹温柔', isWarning: false },
      { label: '触觉与颜值天花板', value: 98, note: '蓝眼星空丝滑软体', isWarning: false },
      { label: '梳毛与护理耐心', value: 88, note: '需定期排查肠胃与毛球', isWarning: false },
      { label: '独处安全感依存', value: 65, note: '相对渴望主人常在身边', isWarning: false },
    ],
    stampText: '【仙气核准 · 极致温柔】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：常备一把高密度排梳与化毛膏；它的肠胃略显娇贵，请保持主粮品质稳定；回家时多给它一个拥抱，它会用一整晚的依偎回馈你。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 颜值骄傲',
  },

  british_shorthair: {
    subtitle: '低调圆润体面绅士 · 零负担同居室友',
    categoryBadge: '【合格：标准独立伴侣猫】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你是一个讲究“分寸感”的高级现代人类。你懂得独处的珍贵，也明白生活的体面在于“不给别人添麻烦，也别让别人绑架自己”。你不需要轰轰烈烈的戏剧化冲突，只求日常平稳、省心、有底线。\n\n英短是都市独居生活最完美的搭档。它拥有敦实的包子脸、扎实的骨架和处变不惊的大将风度。它不吵不闹，不跳窗拆家，就坐在书柜顶端以一种哲人的姿态，安静注视着你在人间打拼的每一个日日夜夜。',
    detailedAnalysis: [
      '1. 黄金界限感与独立自洽：你加班到深夜，它绝不会发疯撕扯门帘，而是趴在猫窝里睡眼惺忪地看你一眼，等你放完猫粮就各做各的事。这种成年人之间的默契，让你完全没有任何精神负罪感。',
      '2. 极低照护心智门槛：毛短好打理、体质皮实不易生病、性格稳定如钟。对于节奏紧凑、偶尔需要出差或连轴转工作的你而言，它是最让你放心的后方守护者。',
      '3. 沉稳圆润的肉体抚慰：虽然表面高冷，但只要你伸手过去，它圆滚滚的大脸蛋就会主动凑上来蹭蹭，发出闷雷般的呼噜声，点到即止，恰到好处。',
    ],
    metrics: [
      { label: '独立与省心指数', value: 96, note: '最佳独居合租伙伴', isWarning: false },
      { label: '情绪稳健正态分布', value: 94, note: '处变不惊大将风范', isWarning: false },
      { label: '低维护生活咬合', value: 92, note: '短毛皮实少操心', isWarning: false },
      { label: '包子脸圆润度', value: 98, note: '手感敦实肉感拉满', isWarning: false },
    ],
    stampText: '【体面核准 · 理想合宿】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：注意控制其干饭速度与体重，谨防发腮过度变成小煤气罐；每天准备好清洁猫砂与清水，给它留一个能晒太阳的高处，它就能怡然自得。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 稳健靠谱派',
  },

  siamese_cat: {
    subtitle: '高穿透力声学通讯大师 · 小狗人格猫咪',
    categoryBadge: '【合格：高话密交互猫】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你讨厌死气沉沉的环境。你的性格里潜藏着浓烈的好奇心和表达欲，哪怕平时再累，屋子里如果空无一声，你也会觉得空虚落寞。你希望你的伴侣能对你的一举一动产生高频、热烈甚至带点神经质的即时反馈。\n\n暹罗猫是猫界里披着猫皮的纯种小狗，俗称“挖煤小工”与“声学广播站”。它走路像猎豹、叫声像婴儿，你走到哪它跟到哪，洗澡要扒门、上厕所要监督，用它那双湛蓝的眼睛和碎碎念，把你的一天填得毫无缝隙。',
    detailedAnalysis: [
      '1. 永远有回应的双向唠嗑：你跟它说话，它必定会抑扬顿挫地回叫一声。不管你在外面经历了多大的委屈，回到家有一只小生灵用全身力气向你汇报今天家里发生的一切，孤独感瞬间被碾碎。',
      '2. 极高敏捷度与互动乐趣：它可以学会叼回逗猫棒、跳上你的肩膀充当围脖，甚至跟你玩捉迷藏。它的智商和好奇心能为你的生活注入无穷无尽的生机。',
      '3. 忠贞不二的专属依恋：暹罗一生只认一个主心骨。在它心里，你不是铲屎官，而是它生命的绝对中心。这种被极端偏爱的满足感，是任何社交软件都无法给予的。',
    ],
    metrics: [
      { label: '双向声学交互度', value: 99, note: '从早到晚碎碎念开麦', isWarning: false },
      { label: '小狗人格依恋感', value: 96, note: '出门迎接寸步不离', isWarning: false },
      { label: '好奇心探索欲', value: 92, note: '上天入地侦查小能手', isWarning: false },
      { label: '挖煤糊脸变色率', value: 85, note: '越冷脸越黑的变色龙', isWarning: false },
    ],
    stampText: '【话密核准 · 偏爱专属】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：请做好每天被它叫醒聊天的准备；冬天请为它备好保暖毛衣，否则它的鼻头和爪子会像挖煤一样越冻越黑；多跟它说话，它是真的听得懂。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 黏人话痨',
  },

  orange_tabby_cat: {
    subtitle: '高碳水松弛感大宗师 · 压舱级干饭哲学',
    categoryBadge: '【合格：高耐受松弛型猫】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你是一个深谙“人间清醒”的生活家。你早就看穿了现代内卷社会的无聊游戏，深知世间万般烦恼，抵不过热腾腾的一碗碳水和睡到自然醒的大懒觉。你身上的松弛感，是抵御一切时代焦虑的终极护盾。\n\n中华田园橘猫，别名“橘座”与“压秤大仙”。大橘为重，十橘九胖。它对生存环境毫不挑剔，适应力拉满，最大的追求就是干饭与晒肚皮。它将用它那沉甸甸的十五斤肉体，牢牢压住你所有的生活波澜。',
    detailedAnalysis: [
      '1. 天塌下来先吃饱的顶级心态：看橘猫干饭是一种极具催眠效果的精神洗礼。它嘎嘣嘎嘣吃完舔舔嘴，往地上一躺呼噜震天。看着它毫无心理包袱的肥厚肚腩，你脑海里的精神内耗也会自发烟消云散。',
      '2. 超强皮实生命力：它没有名种猫娇滴滴的玻璃胃，抗病耐受力极强，随遇而安。你给它一个纸箱它就能占山为王，用最省心的方式陪伴你度过每一个春夏秋冬。',
      '3. 压仓级肉体接触体验：晚上睡觉把它捞进被窝，如同抱着一块实心的大面包，沉甸甸的重量感能直接激活你副交感神经的放松反射，失眠不药而愈。',
    ],
    metrics: [
      { label: '干饭主动性峰值', value: 99, note: '食盆见底即刻发作', isWarning: false },
      { label: '松弛感与钝感力', value: 98, note: '天塌下来当被子盖', isWarning: false },
      { label: '生命力皮实耐造', value: 96, note: '好养活少生病典范', isWarning: false },
      { label: '体重增长不可逆', value: 92, note: '大橘为重压穿地心', isWarning: true },
    ],
    stampText: '【大橘核准 · 沉甸安宁】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：请务必定期称重并严格控制零食投放；常备一个结实的大号猫砂盆；每天揉捏它的大肚子三次，能有效降低你的皮质醇水平。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 肥美治愈派',
  },

  sphynx_cat: {
    subtitle: '高体温未来主义贴皮暖炉 · 先锋美学黏人精',
    categoryBadge: '【合格：无毛特许伴侣】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你拥有突破世俗庸常的独立审美。你不在乎传统大众对于“毛茸茸才是可爱”的教条定义，你更看重独特的生命质感与深层的灵魂连接。同时，你可能深受鼻炎或掉毛困扰，渴望一种完全不产生飞毛却能极致亲昵的高端陪伴。\n\n斯芬克斯无毛猫就像一只从科幻电影里走出来的三体星生灵。它全身上下只有一层细腻的蜜桃胎绒，常年维持着接近 40℃ 的高体温。它对人类有着如同火门烧红般的依恋，是行走的活体暖手宝。',
    detailedAnalysis: [
      '1. 零飞毛与呼吸道友好：再也不用在衣服、沙发和汤碗里挑猫毛。对于有轻微洁癖或过敏体质的你来说，它让“养猫”与“无尘清爽空间”达成了前所未有的完美和谐。',
      '2. 极度炽热的肉体贴贴：因为没有毛发保温，它天生渴望靠近人类的体温。只要你坐下，它就会像个小猴子一样顺着腿爬进你的大衣怀里，把温热平滑的皮肤紧紧贴在你的胸膛上。',
      '3. 精致生活的仪式投射：定期用温水给它洗澡擦油、换上定制的羊绒小毛衣，这些细致的养护不仅不是负担，反而成为你关照另一个生命、滋养自身责任感的优雅仪式。',
    ],
    metrics: [
      { label: '先锋美学鉴赏力', value: 98, note: '越看越高级的科幻审美', isWarning: false },
      { label: '恒温贴皮黏人度', value: 99, note: '40℃移动活体暖手炉', isWarning: false },
      { label: '无毛环境零负担', value: 100, note: '彻底告别飞毛与鼻炎', isWarning: false },
      { label: '精细护肤耐受度', value: 86, note: '定期温水擦油洗澡', isWarning: false },
    ],
    stampText: '【先锋核准 · 炽热相依】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：冬天请保持室内暖气并给它备齐保暖小衣裳；每周用温水或宠物湿巾清理皮肤油脂；带它出门需涂抹宠物专用防晒，避免晒伤娇嫩表皮。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 极客时尚派',
  },

  rabbit: {
    subtitle: '易碎敏感草食观察者 · 极限静音碎纸机',
    categoryBadge: '【合格：微型草食伴侣】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你是一个内心世界细腻、需要高度低噪环境的温柔个体。你无法忍受家里出现刺耳的尖叫、狂暴的拆家声或无法预测的攻击性冲动。你偏好一种“随风潜入夜，润物细无声”的静谧陪伴，在无声的咀嚼中找寻精神的落脚点。\n\n兔子是自然界创造的最安静、最无害的草食小生灵。它没有发声器官，不会冲你狂吠，只要给它一把清香的提摩西草，它就能鼓着三瓣嘴咔嚓咔嚓嚼上一整天。它的纯洁与无争，将成为你抵御外部噪音的无形结界。',
    detailedAnalysis: [
      '1. 极致静谧的生活场域：除了脚爪踩在地毯上的轻微沙沙声和喝水时的哒哒声，它不会对你的听觉造成任何打扰。在它身旁看书、办公或发呆，整个人都能迅速沉静下来。',
      '2. 慢热却真挚的信任建立：它生性警惕，但当你日复一日轻手轻脚为它添草添水，直到某天它愿意在你脚边侧躺“兔饼”打滚露出脆弱肚皮时，那种被易碎生命全盘托付的感动无与伦比。',
      '3. 天然草本清香：它的排泄物没有肉食动物的恶臭，屋子里常年弥漫着晒干牧草的田野香气，仿佛把微缩版阿尔卑斯山草甸搬进了你的卧室。',
    ],
    metrics: [
      { label: '静音低噪适应力', value: 99, note: '近乎零分贝的绝对安宁', isWarning: false },
      { label: '轻柔慢节奏耐性', value: 92, note: '需动作放慢轻声细语', isWarning: false },
      { label: '草本气味接受度', value: 95, note: '清香牧草自然气息', isWarning: false },
      { label: '易碎胃肠脆弱性', value: 85, note: '禁乱喂零食，无限干草', isWarning: true },
    ],
    stampText: '【静谧核准 · 温和守护】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：必须保证提摩西干草与凉白开无限量供应；室内电线务必套上防咬绝缘管；切勿抓它的长耳朵，温柔抚摸鼻梁是它最爱的社交礼节。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 纯净草食派',
  },

  hamster: {
    subtitle: '单兵地下城基建大师 · 微型仓储独立客',
    categoryBadge: '【合格：微型独居小宠】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你生活在一个高集成度、空间极为宝贵的环境中，或者你本身的日常精力只能支持“低频维护、高赏心悦目”的小确幸。你独立自持，不需要跟谁抱团取暖，但在夜深人静时，你希望桌角有个勤勉打拼的小生命提醒你：生活还在运转。\n\n仓鼠是微缩维度的基建狂魔。不足 0.2 平方米的亚克力箱，就是它独立自主的庞大帝国。它独来独往，两腮藏尽人间烟火，每天深夜在跑轮上健步如飞。它用最低的存在成本，填补你心灵最细微的空缺。',
    detailedAnalysis: [
      '1. 空间与精力的绝对微载：无需下楼遛弯、无需昂贵美容、无需占用整间客厅。一个造景箱放在书桌或床头，每周花二十分钟换换垫料添添粮，就能维持一个完整生灵的终身福祉。',
      '2. 治愈感极强的仓储偷窥：看着它把两颗南瓜籽像变魔术一样塞进两腮，把脸颊撑成小三角形，再小心翼翼钻进小木屋藏好，这种纯粹的吃货本能会让你忍俊不禁。',
      '3. 深夜同频的打工人暗号：当你熬夜赶 PPT 或刷手机到凌晨一点，它刚好打着哈欠走出木屑，爬上跑轮开始它的夜跑马拉松。那一刻，你俩都是在这个世界上悄悄努力的单兵战士。',
    ],
    metrics: [
      { label: '微型空间契合度', value: 100, note: '桌面级0.2㎡独立领地', isWarning: false },
      { label: '超低照护心智负担', value: 95, note: '省心省力无压力', isWarning: false },
      { label: '独居边界自洽度', value: 96, note: '严禁合笼独行侠', isWarning: false },
      { label: '深夜跑轮同频度', value: 88, note: '深夜值班好搭档', isWarning: false },
    ],
    stampText: '【袖珍核准 · 桌面安居】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：必须遵循“一鼠一笼”铁律，严禁合笼互撕；请配备静音轴承跑轮（直径建议≥20cm）；垫料厚铺方便它挖掘地道藏粮食。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 省心小巧派',
  },

  guinea_pig: {
    subtitle: '群居声学尖叫土豆 · 蔬菜雷达探测器',
    categoryBadge: '【合格：温顺声学伴侣】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你喜欢有规律、有期待、温和热闹的生活。你享受被人（或者小动物）强烈期待的感觉——比如一推开门有人迫不及待为你发出欢呼。你有一颗柔软的心，乐意为那些呆呆笨笨的小生命准备新鲜的水果蔬菜，把日常琐碎过得充满烟火气。\n\n荷兰猪（豚鼠）是一颗会尖叫的毛茸茸大土豆。它胆小温驯、毫无攻击力，天生自带“蔬菜雷达”。只要听到冰箱门开或者塑料袋抖动的声音，它就会在笼子里昂起脖子爆发出一连串欢快的“Wheek-Wheek”哨音。',
    detailedAnalysis: [
      '1. 极其强烈的即时情绪反馈：它不像猫狗那样城府深沉，它所有的喜怒哀乐全写在叫声和蹦跳（爆米花跳）里。只要你手里拿着一片洗干净的生菜叶，你就是它整个世界里最受爱戴的救世主。',
      '2. 温驯软萌的贴手手感：体型比仓鼠大得多，捧在怀里沉甸甸像个小毛绒暖水袋。你可以一边看电视一边把它放在膝盖上抚摸，它会一边嚼着草一边发出舒服的咕噜轻叹。',
      '3. 群体互动的生活欢愉：如果养上一对，看着两只毛土豆排成一队在房间地毯上巡逻开火车，彼此用轻快的叫声交头接耳，再灰暗的心情也会瞬间被这幅滑稽可爱的画面点亮。',
    ],
    metrics: [
      { label: '声学反馈充沛度', value: 95, note: '欢快哨音随时迎接', isWarning: false },
      { label: '果蔬喂养乐趣感', value: 92, note: '投喂生菜成就感满载', isWarning: false },
      { label: '温顺零攻击耐性', value: 98, note: '任摸任抱绝不咬人', isWarning: false },
      { label: '维生素C补充保障', value: 85, note: '自身无法合成需额外补充', isWarning: true },
    ],
    stampText: '【萌嘟核准 · 蔬菜特使】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：每日必须足量供给新鲜青草并额外补充维生素 C 水溶滴剂；建议成对饲养以缓解其社交孤单；地垫需勤换洗保持干爽卫生。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 欢脱治愈派',
  },

  chinchilla: {
    subtitle: '神圣极细毛丝仙灵 · 恒温沙浴贵族',
    categoryBadge: '【合格：高阶丝滑毛丝伴侣】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你对生活品质、物理触感和微观美学有着极高的要求。你可能是个重度触觉敏感者，对于劣质粗糙的织物本能排斥，而在面对世间至纯至柔的事物时，能倾注所有的珍惜与细心。同时，你自律且有条理，能维持一个干净、凉爽、秩序井然的室内小气候。\n\n龙猫（毛丝鼠）是造物主在毛发触觉上的最高杰作。一个毛孔长出六十根细绒，摸过它之后，人间所有皮草皆成麻袋。它高贵神圣、极度怕热，每天在火山灰里优雅洗澡，宛如动画大师笔下走出的小精灵。',
    detailedAnalysis: [
      '1. 触觉维度的降维打击：当你伸出一根手指轻轻陷进它丰厚如云雾般的毛层中，那种毫无阻力、丝滑入骨的触感，能瞬间击穿你紧绷一整天的神经突触，带来顶级颅内高潮。',
      '2. 极高洁净度与天然素养：它完全没有体味，皮毛密到跳蚤连落脚的缝隙都找不到。只要每天给它准备一盆细致的火山浴沙，看着它一头扎进去疯狂打滚自洁，治愈感直接拉满。',
      '3. 傲然独立的神性距离：它不会像小狗那样谄媚扑人，但会在熟悉之后敏捷地跳上你的膝盖，用两只粉嫩的小手抓着苹果木磨牙棒啃食。这种克制而高贵的陪伴，最契合讲究品质的灵魂。',
    ],
    metrics: [
      { label: '触觉天花板治愈', value: 100, note: '人间丝滑手感至臻境界', isWarning: false },
      { label: '绝对无味洁癖友好', value: 98, note: '天然沙浴自洁无体味', isWarning: false },
      { label: '夏日恒温控温耐力', value: 90, note: '气温超25℃需全天开冷气', isWarning: true },
      { label: '高寿命长久契约', value: 92, note: '寿命可达15-20年需慎重', isWarning: false },
    ],
    stampText: '【贵胄核准 · 丝滑圣灵】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：夏季环境温度严禁超过 25℃，必须全天候开空调防中暑；每周提供 2-3 次专用浴沙；主食以草砖与专业粮为主，严禁乱喂新鲜多水蔬菜水果。',
    confidentialLevel: 'CL-2 进阶级伴侣档案 · 品质贵族型',
  },

  ferret: {
    subtitle: '无骨骼狂乱搜刮特工 · 拖鞋终结者',
    categoryBadge: '【合格：高敏捷智趣生灵】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你身上流淌着对“冒险、荒诞喜剧和不可预测惊喜”的热爱。你骨子里是个顽童，受够了循规蹈矩的教条生活，渴望家里天天上演动作大片。你有一颗大心脏，对于家里的小物件神出鬼没不仅不恼，反而能乐在其中地当起福尔摩斯。\n\n雪貂是造物主打翻了面条汤制作出的无骨骼多动特工。它身体柔软如液体，好奇心比银河系还大。只要放它出笼，它就会在沙发底、冰箱后四处穿梭，把你的一只袜子、两个遥控器和车钥匙偷偷拖进它的秘密基地。',
    detailedAnalysis: [
      '1. 永不打烊的滑稽喜剧秀：它走路自带摇摆机械舞步，高兴了就在地毯上横着弹跳甩头（著名的战舞）。它那荒谬而欢快的四肢动作，能将你所有的严肃假面彻底撕碎。',
      '2. 极致的互动黏人与捉迷藏：它不仅认识你，还会主动扒你的裤腿求带飞，或者在你走动时钻进你的裤脚里当挂件。跟它生活在一起，家里永远不会有哪怕一分钟的冷场。',
      '3. 规律的充电式作息：虽然醒着时精力如火海，但每天其实要睡足 16 小时以上。当你上班出门时，它在窝里睡得像一条融化的毛巾；等你回家，它准时开机满血复活迎接你。',
    ],
    metrics: [
      { label: '荒诞幽默耐受力', value: 98, note: '每天自导自演谍战喜剧', isWarning: false },
      { label: '搜刮寻宝包容度', value: 95, note: '床底下藏着半打拖鞋', isWarning: false },
      { label: '亲人黏合活跃度', value: 94, note: '跳跃奔跑全身都是戏', isWarning: false },
      { label: '物理防钻防逃密封', value: 86, note: '凡有缝隙必被钻穿', isWarning: true },
    ],
    stampText: '【狂欢核准 · 特工入驻】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：封堵室内所有直径超过 5cm 的缝隙与孔洞；收纳好贵重首饰与钥匙；必须保证纯肉食高蛋白饮食；每天保证至少 2 小时的放风互动时间。',
    confidentialLevel: 'CL-2 进阶级伴侣档案 · 智趣欢乐派',
  },

  parrot: {
    subtitle: '高智商羽翼相声演员 · 破晓高音喇叭',
    categoryBadge: '【合格：高智语言鸟类】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你拥有一颗热烈、渴望交流、能容纳高分贝热闹的心。你习惯了在嘈杂的世界里捕捉幽默，甚至自己就是社交圈里的段子手。你无法忍受冰冷沉默的房间，你希望回到家有声音、有对话，哪怕对话的内容只是一句字正腔圆的“你好，干饭！”\n\n鹦鹉不是普通的鸟，它是一个长了翅膀、能活几十年、且永远处于叛逆期的相声演员。它不仅聪明通人性，还能复刻你的语气、手机铃声以及你下班回家脱鞋时叹的那声长气。有它在，你的家就是德云社分社。',
    detailedAnalysis: [
      '1. 跨物种语义交流奇迹：当你走进房间，它歪着脑袋清脆地喊出你的名字，或者在你接电话时冷不丁在旁边接一句“啊对对对”，那种魔幻又真实的跨物种沟通会让你笑到捶地。',
      '2. 极度深厚的人格依恋：高智商鸟类有着不输于狗的情感深度。它会主动飞到你的头顶或肩膀上，用喙温柔地帮你整理头发，甚至闭着眼睛任由你抚摸它后颈的羽毛。',
      '3. 漫长的人生同舟者：大型鹦鹉的寿命长达数十年，甚至能见证你的结婚、生子与退休。它不是你生命中的过客，它是贯穿你整个下半生的羽翼守护神。',
    ],
    metrics: [
      { label: '声学分贝耐受上限', value: 96, note: '破晓高音喇叭毫不畏惧', isWarning: false },
      { label: '智力交互与语义趣味', value: 98, note: '语言模仿与相声搭档', isWarning: false },
      { label: '长情伴随寿命预期', value: 95, note: '几十年如一日长久羁绊', isWarning: false },
      { label: '羽屑清理包容度', value: 82, note: '需配备空气净化设备', isWarning: false },
    ],
    stampText: '【啼鸣核准 · 岁月共鸣】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：请确保合法饲养合规品种（如玄凤、虎皮、牡丹等需对应资质）；严禁厨房油烟及特氟龙涂层锅具挥发；每天提供新鲜蔬果、坚果与社交互动。',
    confidentialLevel: 'CL-2 进阶级伴侣档案 · 活泼长寿型',
  },

  betta_fish: {
    subtitle: '桌面静默水下斗士 · 极简美学静物',
    categoryBadge: '【准养：极简桌面水族】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你是一个深度的精神内敛者，日常生活节奏紧张，社交电量极易见底。你希望拥有生命相伴的温度，但完全没有多余的心力去应对遛狗、铲屎、换毛或夜半吠叫。你追求极致的秩序与美感，能在微缩的静态世界里获得巨大的平静。\n\n斗鱼是属于现代都市青年的桌面赛博水族。它拥有如高定晚礼服般绚丽飘逸的丝鳍，性格孤傲好斗，且具备迷鳃呼吸器官，无需加氧泵也能怡然自得。在显示器旁边摆一个小巧的水草缸，它就是你书桌上一尊活着的艺术品。',
    detailedAnalysis: [
      '1. 零社交消耗的终极省心：不掉毛、不发声、不破坏家具、不产生异味。每天只需要投喂几粒微小颗粒粮，隔周用软管换掉三分之一的晾晒水，维护成本几乎为零。',
      '2. 凝神静气的视觉减压：工作代码写卡壳、方案改到抓狂时，转头看它在翠绿水草间悠然穿行，摆动如烟霞般的鱼鳍，那种纯净的水下律动能在两分钟内重置你的躁乱心绪。',
      '3. 微型桌面的私属领地：它不需要占据你昂贵的居所面积，仅需一杯水的小小世界，就能撑起一整个充满生机的微观生态，是极简生活主义者的最高境界。',
    ],
    metrics: [
      { label: '极简低能耗维护', value: 100, note: '免加氧低门槛省心典范', isWarning: false },
      { label: '静默视觉解压指数', value: 96, note: '绚烂丝鳍凝神冥想', isWarning: false },
      { label: '空间微型化契合', value: 99, note: '书桌一角即可安家', isWarning: false },
      { label: '独行好斗领地意识', value: 95, note: '单缸单养严禁混战', isWarning: false },
    ],
    stampText: '【静水核准 · 极简生灵】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：一缸一鱼，严禁两条公鱼同缸以免死斗；换水需使用提前晾晒除氯的水；冬季北方室内需配备微型低瓦数加热棒保持水温在 24-28℃。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 桌面极简派',
  },

  turtle: {
    subtitle: '玄武级长寿冥想大师 · 零焦虑时间领主',
    categoryBadge: '【准养：玄武长寿水宠】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你拥有超脱凡俗的宏大时间观。你深知急功近利是现代人的绝症，而真正的力量蕴含在慢速的蓄力与静默的坚守之中。你做事情喜欢拉长周期看趋势，对于一时的得失波澜不惊。你的精神内核稳重如磐石，耐得住漫长的寂寞。\n\n乌龟是这颗星球上最古老的时间领主之一。它心跳极缓，四脚平稳，不慌不忙。当你为房贷、考核或失恋焦头烂额时，它在晒台上伸长脖子烤太阳，以一种阅尽沧海桑田的冷淡眼神看着你。养得好，它甚至能顺便把你送走。',
    detailedAnalysis: [
      '1. 降维打击式的心理减压：这世界上没有任何事能让一只乌龟慌张。看着它慢条斯理地划水、一口一口撕咬小鱼干，你会突然意识到：宇宙这么大，急个什么劲呢？所有的焦虑都被它龟壳上的同心纹彻底化解。',
      '2. 极低交互消耗与极高抗灾力：哪怕你出差两周，备好晒台和过滤，它也能安然自若。冬眠季节它甚至直接闭关数月，不需要你操半点闲心，简直是出差狂魔与佛系青年的守护神。',
      '3. 跨越时代的岁月长河：它陪伴你的周期不是猫狗短短十几年，它可能是贯穿你少年、中年直至耄耋之年的不朽见证者。它是你人生起伏中最沉默却最长情的基石。',
    ],
    metrics: [
      { label: '时间跨度抗周期', value: 100, note: '甚至能顺便送你走', isWarning: false },
      { label: '佛系极简维护度', value: 97, note: '出差两周安然无恙', isWarning: false },
      { label: '心率平稳钝感力', value: 99, note: '不慌不忙冥想大师', isWarning: false },
      { label: '晒背日光浴需求', value: 85, note: '需配备UVA/UVB全光谱灯', isWarning: false },
    ],
    stampText: '【玄武核准 · 岁月恒远】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：养水重于养龟，水质过滤必须到位；配备全光谱晒背灯与晒台；冬眠前需排空肠胃并健康检查，避免在虚弱状态下入冬。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 佛系长寿派',
  },

  axolotl: {
    subtitle: '远古微笑再生奇迹 · 永不长大的粉嫩两栖体',
    categoryBadge: '【特许：两栖奇迹生灵】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你心里住着一个不愿向残酷成人世界彻底投降的孩子。你对于“奇特、梦幻、幼态与奇迹”有着天然的好奇心。你享受照料一个稍微娇贵但极度特别的生灵，借此在冰冷机械的现实丛林里，守护一块完全属于自己的童话秘境。\n\n六角恐龙（美西钝口螈）是两栖界的微笑精灵。它拥有永不闭合的天然微笑唇、六根红珊瑚般的羽状外鳃，以及令人惊叹的四肢器官再生能力。它浮在清澈的水里，呆呆地看着你，宛如从宫崎骏动画里游出来的神圣水怪。',
    detailedAnalysis: [
      '1. 终极呆萌的精神洗礼：它的黑豆小眼睛和天生上扬的嘴角，构成了世界上最治愈的无公害表情。当你因为工作疲惫不堪地趴在鱼缸前，它会慢吞吞划动小短腿游过来隔着玻璃和你对视，所有负能量瞬间融化。',
      '2. 纯粹安静的水中雕塑：它没有肺，全靠华丽的外鳃在冷水里缓缓扇动。它不吵、不闹、不争宠，静静地趴在沉木下，像一座散发着梦幻荧光的活着的手办。',
      '3. 细致温控的责任投射：它极度怕热，水温必须常年压在 20℃ 以下。为你心爱的小恐龙配置冷水机、调节水流，这种精细照护的成就感，能让你重新体会到对生命的敬畏与深情。',
    ],
    metrics: [
      { label: '呆萌微笑治愈力', value: 100, note: '永不长大的奇迹幼态', isWarning: false },
      { label: '梦幻外观鉴赏度', value: 98, note: '红珊瑚羽鳃宛若神话', isWarning: false },
      { label: '冷水环境温控要求', value: 92, note: '夏季水温必须≤20℃需冷水机', isWarning: true },
      { label: '静默水质维稳耐受', value: 88, note: '裸缸或大鹅卵石防误吞', isWarning: false },
    ],
    stampText: '【奇迹核准 · 梦幻两栖】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：夏季必须配备水族冷水机压制水温（严禁超过 22℃）；缸底严禁使用细小沙石底砂，谨防它大嘴误吞造成肠梗阻；以沉水性肉食颗粒或红虫定点投喂。',
    confidentialLevel: 'CL-2 进阶级伴侣档案 · 梦幻小众型',
  },

  leopard_gecko: {
    subtitle: '定点排便冷峻小恐龙 · 静音箱装守望者',
    categoryBadge: '【准养：冷血观赏特许生灵】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你是一个高智、追求高能效比、极其讲究秩序的现代独立个体。你对生活的要求是“干净、利落、杜绝任何无谓的熵增”。你欣赏冷冽小众的自然之美，比起大喊大叫的浮躁，你更青睐在箱庭微缩世界里默默运行的精密生态。\n\n豹纹守宫是爬宠界公认的第一模范公民。它长着绚丽如豹皮的几何花纹、一对晶莹的立瞳和一条储存营养的肥美肉尾巴。它不掉毛、不吠叫、没有异味，甚至会自律地在饲养箱固定角落上厕所。它是为高品位都市人类量身定制的静默密友。',
    detailedAnalysis: [
      '1. 零熵增的洁癖友好型伴侣：彻底告别毛发飞扬与猫砂异味。它的排泄物干爽且必定排在同一个固定角落，用小镊子一秒即可夹除。对于注重居室一尘不染的你，它是无懈可击的完美搭档。',
      '2. 极低频率的维生节奏：成年守宫两到三天喂一次蟋蟀或面包虫，水盆加满，你哪怕周末出差三天，它也能在加热垫上趴得舒舒服服。你的出行与自由完全不会被它束缚。',
      '3. 冷血外表下的反差萌感：虽然顶着小霸王龙般的外形，但它吃完东西会用粉红色的小舌头一圈圈舔嘴唇舔眼睛，甚至在脱完皮后歪头看着你。这种克制而精巧的萌感，高级感十足。',
    ],
    metrics: [
      { label: '自律定点排便满分', value: 100, note: '洁癖星人终极梦想', isWarning: false },
      { label: '低频喂养自由度', value: 96, note: '两三天一喂出差无忧', isWarning: false },
      { label: '零噪音无扰共存', value: 99, note: '安安静静不打扰一秒', isWarning: false },
      { label: '活体昆虫饲喂耐受', value: 85, note: '需克服给虫子裹钙粉的心理', isWarning: false },
    ],
    stampText: '【守宫核准 · 箱庭优雅】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：饲养箱必须营造冷热分区（热区加热垫保持 30-32℃）；常备含 D3 钙粉与维生素粉在喂食时包裹活饵；配备一个湿润躲避屋方便其规律蜕皮。',
    confidentialLevel: 'CL-1 公开级伴侣档案 · 极简冷峻派',
  },

  bearded_dragon: {
    subtitle: '趴在肩头的迷你霸王龙 · 日光浴手势外交官',
    categoryBadge: '【准养：温驯鬃狮蜥特许】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你的性格里带着反差的张力——表面可能显得特立独行甚至让人觉得有些不好惹，但熟悉你的朋友都知道你内心极其温厚、踏实、重情义。你喜欢硬朗帅气的事物，同时又渴望一种能真真切切带在身上、随行随走的高配合度互动。\n\n鬃狮蜥被称为“爬宠界的大金毛”。它长着一身带刺的装甲鳞片、威风凛凛的颌下胡须，活脱脱一只微型侏罗纪暴龙。然而它的真实性格软萌到不可思议：只要你伸手，它就会乖乖爬上你的手臂，老老实实趴在你的肩膀上晒太阳，甚至跟你一起看电视。',
    detailedAnalysis: [
      '1. 霸道外表与极度温顺的究极反差：任你抚摸后背与下巴，它只会舒服地闭上眼睛伸展四肢。你可以把它直接放在肩膀上在屋里巡视，它就是你身上最炫酷的一件活体机能挂饰。',
      '2. 奇妙丰富的手势社交语言：它高兴了会慢悠悠做“打招呼招手”手势，威严了就微微鼓起黑胡子，或者缓缓点头。这种古老生灵的肢体密语，充满让人会心一笑的荒诞魅力。',
      '3. 杂食喂养的烟火乐趣：不仅吃昆虫，还酷爱吃油麦菜、南瓜丝和胡萝卜。看着一只全身装甲的小恐龙在大嚼绿叶青菜，这种视觉冲击力既滑稽又极具生活美感。',
    ],
    metrics: [
      { label: '亲人趴肩互动度', value: 96, note: '爬界金毛温顺至极', isWarning: false },
      { label: '硬派霸王龙颜值', value: 98, note: '装甲鳞片视觉冲击力', isWarning: false },
      { label: '杂食喂养烟火乐趣', value: 90, note: '荤素搭配大口吃菜', isWarning: false },
      { label: '高瓦数太阳灯配置', value: 88, note: '需专业UVB灯管与晒台', isWarning: true },
    ],
    stampText: '【鬃狮核准 · 硬汉柔情】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：饲养箱长度建议≥100cm；必须配备专业 UVB10.0 灯管与太阳聚光灯营造 38℃ 晒点；幼体以活体昆虫为主，成体需逐步过渡到 70% 蔬菜水果杂食。',
    confidentialLevel: 'CL-2 进阶级伴侣档案 · 酷炫硬派型',
  },

  corn_snake: {
    subtitle: '零内耗冰感几何艺术品 · 终极静默密友',
    categoryBadge: '【特许：无毒冷血伴侣蛇】',
    badgeType: 'normal',
    systemVerdict:
      '系统综合鉴定：你是一位极致的情绪极简主义者。你深刻理解现代社交里充斥的虚伪、多余与内耗，你厌恶任何情绪勒索与无理取闹。你追求一种极致纯净、不带杂质、不需要任何世俗言语交换的高维陪伴。你的精神力量极其强大，能够享受孤独，并在清澈的冷峻中汲取能量。\n\n玉米锦蛇是造物主用几何美学雕琢出的活体锦缎。它无毒、温驯、没有任何体味与声音，鳞片冰凉如玉。它一周只需要进食一次，其余时间在隐秘处静静盘踞。缠绕在你手腕上的那一抹冰凉，能瞬间冰镇你所有翻滚的焦虑。',
    detailedAnalysis: [
      '1. 彻底消灭一切社交摩擦：它不会向你索取任何情绪价值，也不会因为你加班晚归而怨恨你。它不需要你的讨好，它只是静静存在着，与你共享同一个物理空间，互为彼此最安全的宇宙坐标。',
      '2. 玉石般的极致物理触感：轻轻握在手心，感受它强劲而柔软的肌肉群在指缝间顺滑地游移，那种干燥、微凉、如抛光大理石般的触觉反馈，是世界上最高级的感官平静剂。',
      '3. 规律蜕变的生命隐喻：数月一次的完整蜕皮，象征着一次彻底告别过去的生命重生。看着它褪去黯淡旧衣、以崭新绚丽的鲜活身姿重回光明，能给你带来极大的心理疗愈与重生意志。',
    ],
    metrics: [
      { label: '零内耗绝对清净', value: 100, note: '毫无噪音与情绪勒索', isWarning: false },
      { label: '冰凉玉石触觉质感', value: 98, note: '指尖游移顺滑平静', isWarning: false },
      { label: '超低频喂食周期', value: 99, note: '一周仅需喂食一次', isWarning: false },
      { label: '防越狱安全锁闭', value: 95, note: '逃生大师箱盖必须扣紧', isWarning: true },
    ],
    stampText: '【灵蛇核准 · 极静相守】',
    stampType: 'normal',
    coexistenceAdvice:
      '💡 饲养建议：饲养箱必须配备防越狱卡扣与卡扣锁，谨防其顺着缝隙离家出走；投喂解冻冷冻乳鼠（严禁活体投喂以防咬伤）；进食后 48 小时内切勿上手把玩以免反刍。',
    confidentialLevel: 'CL-2 进阶级伴侣档案 · 冷静先锋型',
  },

  // ==================== 抽象角色池 (10 种) ====================

  nailong: {
    subtitle: '超现实高维黄化幼龙 · 纯度 99% 快乐降智核爆',
    categoryBadge: '【警报：已排除全部常规碳基动物】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：在现有已知的 428 种常规家养哺乳动物中，没有任何一种碳基生物能够安全承受你当前的精神状态与生活作息。若强行匹配常规猫狗，极易造成宠物单方面抑郁、无故脱毛或过早看破红尘。\n\n依照《非常规生物收容与精神互补条例》第七款，系统已紧急越权调用低多边形高维收容库，正式指派高维魔性神圣造物——「奶龙」接管你的人生。既然世界是一座巨大的草台班子，不如跟着它一起吃块炸鸡，把所有正经规矩统统甩到脑后！',
    detailedAnalysis: [
      '1. 物理级降智与抗内耗光环：该生物天生自带高频降智力场。当你深夜陷入自责、焦虑或对人生意义进行形而上思考时，它会站在你肚子上发出咯咯傻笑，用最纯粹的低智商光环强行物理阻断你的负面神经回路。',
      '2. 极低生活维护门槛：无需每日清晨风雨无阻下楼遛狗，也无脱发与打翻花瓶之虞。其主要生存燃料为外卖炸鸡、冰红茶以及各类高热量碳水。在遭遇现实不可调和的矛盾时，它将为你执行终极外交策略——在对手面前疯狂无厘头甩头。',
      '3. 宿命级双向同化：根据测试指标显示，你与该生物在「摆烂耐力」、「情绪抗揍度」与「抽象浓度」上契合度极高，你们注定将在同一个屋檐下把生活过成一部荒诞短剧。',
    ],
    metrics: [
      { label: '抽象浓度', value: 99, note: '极高危 · 精神污染外溢', isWarning: true },
      { label: '摆烂指数', value: 96, note: '几乎与床垫发生物理熔接', isWarning: true },
      { label: '现实自理能力', value: 12, note: '勉强维持生命体征', isWarning: true },
      { label: '降智抗内耗光环', value: 95, note: '遇事不决直接甩头', isWarning: false },
    ],
    stampText: '【绝密收容 · 强制绑缚】',
    stampType: 'danger',
    coexistenceAdvice:
      '⚠️ 饲养警示：切勿试图教导它微积分或人生哲学，那会烧毁它本就不大的脑干；建议在玄关常备全家桶，遇到困难请大声呼喊它的名字。',
    confidentialLevel: 'CL-4 绝密级精神档案 · 禁止在严肃长辈面前展示',
  },

  naiwa: {
    subtitle: '二创叛逆精神同化体 · 可爱核污染与死鱼眼大宗师',
    categoryBadge: '【特批：高维二创精神解构体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：你的精神骨架里长满了锋利的逆骨与反叛因子。你表面上在循规蹈矩地上班打卡，实则内心早已把所有世俗教条和虚伪权威解构成了表情包。你反感一切爹味说教，也看透了那些冠冕堂皇的人生大道理，你只想用最荒诞、最呆滞的姿态对抗这荒谬的现实。\n\n「奶蛙」脱胎于中文互联网最狂暴的二创叛逆浪潮。它拥有标志性的死鱼眼、微不可察的嘲讽唇角以及失控的呆萌身段。它不是任何传统文明体系认可的合规宠物，它是你反抗内卷与虚伪精神的终极图腾。',
    detailedAnalysis: [
      '1. 死鱼眼对视的绝对解构力：面对老板画的大饼或现实沉重的压力，转头看看它那双毫无波澜、写满“你在放什么厥词”的死鱼眼，你会瞬间笑场。世间万物的沉重感，在它的死鱼眼前都会灰飞烟灭。',
      '2. 可爱核污染与精神外耗：它践行着当代年轻人的核心哲学——与其内耗自己，不如发疯外耗别人。谁惹你不爽，它就带你在对方面前倒立吐泡泡，实施无差别的降智精神打击。',
      '3. 纯正的互联网精神共谋：在深夜的屏幕荧光下，你们一起刷着魔性切片、喝着冰红茶。它懂你每一次冷笑背后的疲惫，也支持你每一个看似荒唐的摆烂决定。',
    ],
    metrics: [
      { label: '逆反反骨指数', value: 98, note: '反世俗权威与道德绑架', isWarning: true },
      { label: '死鱼眼精神钝感', value: 96, note: '物理级免疫一切焦虑', isWarning: false },
      { label: '抽象浓度', value: 95, note: '高浓度冲浪解构本能', isWarning: true },
      { label: '情绪外耗攻击力', value: 92, note: '遇事不决先发个癫', isWarning: false },
    ],
    stampText: '【绝密收容 · 叛逆核准】',
    stampType: 'danger',
    coexistenceAdvice:
      '⚠️ 饲养警示：切勿试图用传统成功学对它进行规训，那会加速它的死鱼眼嘲讽反射；建议玄关常备脆皮炸鸡，心情不好请立刻与它进行五分钟无意义对视。',
    confidentialLevel: 'CL-4 绝密级精神档案 · 请勿在正经领导前展示',
  },

  niulai: {
    subtitle: '粗糙生命力逆袭奇行种 · 荒诞草莽战神',
    categoryBadge: '【隔离：非标准野生收容体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：你身上潜藏着一种野蛮粗粝、完全未经修剪的原生生命力。你受够了中产阶级那些精致脆弱的伪善面具，你更崇尚“泥里摸爬滚打照样横冲直撞”的硬核逻辑。在现实的重拳砸下来时，你或许会倒地打滚，但滚完之后爬起来，你依然能带着满身泥巴咧嘴大笑。\n\n「牛来」是互联网野生生态里杀出来的草莽奇行种。它粗糙、猎奇、毫不讲究逻辑，但它有着打不死的野蛮冲劲与莫名其妙的逆袭气场。它将在你最灰暗的时刻，带你像蛮牛一样冲碎所有无聊的条条框框。',
    detailedAnalysis: [
      '1. 纯粹野蛮的抗击打韧性：它没有细腻的情感创伤，也没有玻璃心的内耗。不管生活怎么折腾它，它抖抖身上的土，下一秒又是一条好汉。这种皮实到极点的钝感力，是现代人最匮乏的铠甲。',
      '2. 毫无偶像包袱的荒诞日常：与它共处，你不需要维持任何体面。你可以穿起大裤衩人字拖，跟它在客厅地板上比划摔跤。它能让你找回最原始、最不讲道理的放肆快乐。',
      '3. 逆天改命的奇妙气场：在这个大家都死气沉沉的世界里，它带着一身野气横冲直撞，莫名其妙就能在绝境里给你撞出一条生路来。',
    ],
    metrics: [
      { label: '粗糙生命力峰值', value: 99, note: '泥坑打滚依然生龙活虎', isWarning: false },
      { label: '草莽战神抗造度', value: 97, note: '抗击打能力突破常规', isWarning: false },
      { label: '失控冲撞动能', value: 92, note: '低思考高行动莽夫流', isWarning: true },
      { label: '体面精致脱敏度', value: 95, note: '彻底粉碎中产容貌焦虑', isWarning: false },
    ],
    stampText: '【野蛮核准 · 战神出征】',
    stampType: 'danger',
    coexistenceAdvice:
      '⚠️ 饲养警示：请把家里易碎的高级花瓶统统收起来；不要试图跟它讲道理，给它一个大西瓜它就能冲锋陷阵；遇到强敌请大喊一声“牛来！”',
    confidentialLevel: 'CL-3 限制级精神档案 · 草莽狂欢派',
  },

  daishu: {
    subtitle: '全天候憨厚底盘托底机 · 胆子放心变肥保护伞',
    categoryBadge: '【收容：高能安全托底体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：测试数据显示，你在现实生活中承担了远超年龄的责任与压力。你总在扮演那个靠谱、稳重、照顾所有人体面的人，但夜深人静时，你的内心其实已经快被掏空了。你极度渴望被无条件地接纳、被一堵宽厚温暖的大肚皮牢牢挡在身后，哪怕你变胖、变懒、变无能，对方也绝不会离开半步。\n\n「袋鼠」是超高安全感的高维治愈化身。它通体金黄憨厚，底盘稳如泰山。它的座右铭就是“别怕，有我兜着，你的胆子放心变肥！”它能为你阻挡世间一切刻薄的冷风。',
    detailedAnalysis: [
      '1. 无限宽容的安全感肚皮：无论你在外面经历了多少委屈、搞砸了多少事情，一头扎进它软乎乎的大肚子上，它会用圆滚滚的手臂轻轻拍拍你的背。在这里，你不需要优秀，你只需要存在。',
      '2. 物理级外卖碳水加持：它懂得最朴素的治愈法则——吃饱了就不难过了。它会准时催促你吃热气腾腾的饭菜，把你从节食焦虑与工作虚无中一把拽回饱腹的踏实人间。',
      '3. 坚不可摧的终极后盾：虽然长得憨态可掬，但只要有谁敢欺负你，它宽厚沉重的身躯会立刻横在你的身前，像一堵无法逾越的高墙，给你最硬核的偏爱。',
    ],
    metrics: [
      { label: '托底安全感饱和', value: 100, note: '绝对包容的温暖后盾', isWarning: false },
      { label: '身心放松治愈度', value: 98, note: '胆子放心变肥无容貌焦虑', isWarning: false },
      { label: '外卖干饭幸福感', value: 95, note: '碳水就是终极多巴胺', isWarning: false },
      { label: '防御反弹力场', value: 92, note: '为宿主弹开一切负面评价', isWarning: false },
    ],
    stampText: '【安全核准 · 终极庇护】',
    stampType: 'danger',
    coexistenceAdvice:
      '💡 饲养建议：当感觉压力爆表时，请立刻拥抱它的大肚皮至少三分钟；允许自己偶尔吃一顿高热量夜宵，记住：有它在，天塌下来也是个好玩的气球。',
    confidentialLevel: 'CL-3 限制级精神档案 · 治愈托底派',
  },

  xionggou: {
    subtitle: '低思考高动能重装蛮牛 · 先干再说被带偏专家',
    categoryBadge: '【警报：大动能莽撞实体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：你是一个容易陷入“过度分析而裹足不前”的现代脑力受害者。你聪明、想得多，但往往也因为推演了太多失败的可能，导致计划无限搁浅、精神反复内耗。你真正需要的不是更多的知识或更严密的逻辑，而是一个脑干缺失、先干再说的二愣子队友。\n\n「熊狗」是大动能、低思考的行动派代表。它的脑回路只有一根直肠通到底，面对困难从不规划路线，直接一路撞过去。虽然经常干出一些让人哭笑不得的蠢事，但它能以惊人的动能带你强行打破拖延魔咒。',
    detailedAnalysis: [
      '1. 物理阻断过度思考：当你在家里为某个方案犹豫不决两个小时时，它已经一头撞开大门把飞盘叼到了你面前。它用最原始的蛮力告诉你：动起来，事情就已经解决了一半。',
      '2. 极易被带偏的滑稽相伴：它憨厚又轻信，你随口一句玩笑它都能当真去执行。看着它卖力地刨坑或者跟自己的尾巴较劲，你会觉得原来人生不需要那么多宏大的意义。',
      '3. 硬核的重力伙伴：虽然看起来粗线条，但当它在冬夜挨着你躺下，那一身滚烫敦实的厚重皮肉，能给你带来最直接、最不需要怀疑的肉体陪伴。',
    ],
    metrics: [
      { label: '莽撞行动力峰值', value: 99, note: '脑子没动肉体先冲', isWarning: false },
      { label: '过度思考粉碎力', value: 96, note: '物理级强行打断拖延', isWarning: false },
      { label: '容易被带偏指数', value: 92, note: '傻乎乎信以为真', isWarning: false },
      { label: '家具抗造耐久警戒', value: 80, note: '偶尔会不小心撞歪茶几', isWarning: true },
    ],
    stampText: '【重装核准 · 蛮力破局】',
    stampType: 'danger',
    coexistenceAdvice:
      '⚠️ 饲养警示：给它指令时请尽量短小精炼，字数超过十个它的大脑会发生热过载；家具尽量选择实木防撞款；遇到想不通的事，跟它一起去户外跑两圈。',
    confidentialLevel: 'CL-3 限制级精神档案 · 行动莽夫流',
  },

  beishou_fushu: {
    subtitle: '表面老干部内心已炸穿 · 绝命装死冷处理宗师',
    categoryBadge: '【特批：高维冷处理收容体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：你的社会化伪装已经达到了炉火纯青的境界。你在外人看来体面、淡定、从容不迫，甚至像个在机关单位摸鱼三十年的成熟老干部；但在你的内心深处，灵魂早已倒在地上蹬腿抽搐了一万次。你深谙“装死是最高明的防御”，在重压之下，你只想倒背双手，冷眼看着一切滑向荒诞。\n\n「背手负鼠」是当代职场人精神形态的完美复刻。它常年倒背着双手，神情淡定自若，仿佛在视察受灾现场；一旦外界压力超过阀值，它会以极其迅捷的身手当场翻白眼原地暴毙（装死）。它是你无声对抗荒谬世界的最高指导员。',
    detailedAnalysis: [
      '1. 表面从容与内心解构的神级默契：当工作群里艾特全员爆雷时，你俩可以在客厅保持同一姿势倒背双手，面带慈祥的微笑对视三秒，然后心照不宣地关掉手机去泡一杯枸杞茶。',
      '2. 极致的危机冷处理哲学：真正的聪明人从来不接从天而降的飞刀。当麻烦找上门来，跟它学一学原地装死——只要你先咽气，别人就没办法把责任甩给你。',
      '3. 零能量消耗的优雅摆烂：它不需要你带它跑步，也不需要你给它梳毛。它最大的爱好就是在阳台角落背着手溜达巡视，以无机物般的安静陪你度过每一次精神风暴。',
    ],
    metrics: [
      { label: '老干部背手淡定度', value: 99, note: '视察灾区般处变不惊', isWarning: false },
      { label: '绝命装死脱敏技巧', value: 98, note: '只要我先死困难就伤不到我', isWarning: false },
      { label: '内心崩坏解构力', value: 95, note: '外表波澜不惊内心狂啸', isWarning: true },
      { label: '能量消耗极简指标', value: 15, note: '能动动嘴皮绝不挪窝', isWarning: false },
    ],
    stampText: '【绝密收容 · 装死特许】',
    stampType: 'danger',
    coexistenceAdvice:
      '💡 饲养建议：当它突然翻白眼吐舌头倒在地上时，请不要惊慌报警，那是它在执行标准避险协议；泡好一杯热茶放在它旁边，等风头过了它自己会站起来继续背手巡视。',
    confidentialLevel: 'CL-4 绝密级精神档案 · 职场老炮派',
  },

  xiugou: {
    subtitle: '极度清澈愚蠢单向奔赴者 · 赛博小狗能量包',
    categoryBadge: '【合格：纯真碳基共振体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：在这个尔虞我诈、步步为营的成年人世界里，你已经太久没有感受过“纯粹而毫无算计的善意”了。你见过太多画大饼、利益交换与留一手，你的心被包裹上了一层厚厚的反欺骗铠甲。但在内心最隐秘的角落，你比任何人都渴望被一个笨拙而真诚的灵魂毫无保留地奔赴一次。\n\n「修勾」是互联网语境中最纯净的赛博小狗图腾。它的脑回路是一根毫无杂质的直线，眼里盛满了不含任何功利的光。你给它一根骨头，它就能把命给你；在它心里，你不是一个平庸的打工人，你是拯救银河系的宇宙之神。',
    detailedAnalysis: [
      '1. 击穿一切冷漠的单向奔赴：无论你今天搞砸了什么、无论银行卡余额多么难看，只要你推开门，它就会像个小炮弹一样带着震耳欲聋的快乐扑进你的怀里。那一刻，所有的世俗评价标准都不复存在。',
      '2. 清澈而愚蠢的治愈笑容：它不懂什么是职场 KPI，也不懂什么叫房贷利息。它只知道你在家它就很开心。看着它吐着舌头晃动小短尾巴，你的心房会被最纯粹的温热彻底泡软。',
      '3. 永不背叛的情感救赎：在这个人人都在权衡利弊的时代，它是你唯一的无条件忠诚盟友。它把全部的生命与信任都交到了你手里，让你重新找回被爱与去爱的勇气。',
    ],
    metrics: [
      { label: '清澈愚蠢忠诚度', value: 100, note: '眼里满是纯真星光', isWarning: false },
      { label: '单向奔赴多巴胺', value: 99, note: '下班开门飞扑抱满怀', isWarning: false },
      { label: '心机防御瓦解力', value: 96, note: '彻底卸下成年人防备', isWarning: false },
      { label: '直肠脑回路指标', value: 92, note: '快乐极其简单易满足', isWarning: false },
    ],
    stampText: '【纯真核准 · 终生奔赴】',
    stampType: 'danger',
    coexistenceAdvice:
      '💡 饲养建议：请用最温柔的语气跟它讲话；出门一定要牵紧牵引绳，谨防它因为太开心而原地起飞；每天多摸摸它的小狗头，它能把快乐分你一半。',
    confidentialLevel: 'CL-2 进阶级伙伴档案 · 极致真诚派',
  },

  shutiao_xiaomao: {
    subtitle: '无害低能耗碳水猫咪 · 毫无攻击性的荒谬存在',
    categoryBadge: '【特批：微型无害抽象造物】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：你目前的精神能量已经处于“超低功耗待机”状态。你受够了一切高烈度的争吵、高难度的挑战和复杂的人际关系，任何带有一丝攻击性或催促感的事物都会让你本能地逃避。你只想被一些软趴趴、热乎乎、没有任何危害、甚至有点荒诞好笑的东西轻轻包围。\n\n「薯条小猫」是一根长了猫咪耳朵与小肉垫的金黄软炸薯条。它为什么是一根薯条？不重要！重要的是它没有爪子、没有脾气、没有攻击性，也不会向你索取任何复杂的猫粮或情感回馈。它就是安安静静躺在你枕头边的一份小可爱。',
    detailedAnalysis: [
      '1. 绝对零攻击性的心灵安全屋：它不会咬人、不会哈气、更不会打翻你的水杯。它就像刚出锅的软炸薯条，全身散发着温热麦香的无害气息，任你怎么揉捏摆弄都毫无怨言。',
      '2. 毫无意义的荒唐治愈：为什么一只猫要长成薯条的样子？当你凝视着它呆萌的小胡子和长条形身段时，脑海里所有紧绷的逻辑大厦都会自发瓦解。在荒诞的世界里，不需要所有事情都有意义。',
      '3. 终极低耗共处模式：它不需要你遛、不需要你铲屎，甚至不需要你陪玩。它只是静静趴在床头当你的小玩偶，在你失眠流泪时，用毛茸茸的薯条尖轻轻蹭蹭你的手背。',
    ],
    metrics: [
      { label: '无害安全感指数', value: 100, note: '绝对零攻击性纯软体', isWarning: false },
      { label: '碳水治愈饱腹感', value: 98, note: '闻起来像刚出炉的暖意', isWarning: false },
      { label: '荒诞低逻辑萌感', value: 95, note: '莫名其妙但极度舒服', isWarning: true },
      { label: '生存能耗需求', value: 5, note: '近乎零消耗陪伴神物', isWarning: false },
    ],
    stampText: '【碳水核准 · 软萌入驻】',
    stampType: 'danger',
    coexistenceAdvice:
      '💡 饲养建议：请勿将其蘸番茄酱食用；在床上给它留一个软垫子；当你觉得人间不值得时，把它抱在怀里吸两口，提醒自己生活还有这般无害的温柔。',
    confidentialLevel: 'CL-3 限制级精神档案 · 软萌无害派',
  },

  diangu: {
    subtitle: '高频精神脱轨加速器 · 纯度 100% 乐子发生器',
    categoryBadge: '【高危：高维精神脱轨实体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：你的脑电波已经脱离了常规碳基生物的引力轨道。你是一个纯粹的乐子人，对死板的正经生活有着生理性的抗拒。你的人生哲学就是“世界迟早要完，不如我们先跳个舞”。在别人还在为现实琐事内耗焦虑时，你早就已经坐在马戏团第一排，开始对着所有荒诞剧目疯狂鼓掌。\n\n「癫菇」是纯失控、纯发癫的高维真菌造物。它通体闪耀着诡异斑斓的荧光，没有一天不在失控旋转。它散布的不是毒素，而是让人神经脱轨、嘴角失守的“快乐孢子”。它将成为你生活中最狂放不羁的精神合谋者。',
    detailedAnalysis: [
      '1. 彻底掀翻一切严肃说教：任何试图在你面前高谈阔论、输出爹味理论的人，都会被癫菇当场喷一脸欢快的彩色孢子，被迫跟着一起摇头傻笑。它就是你身旁最无坚不摧的去爹味神器。',
      '2. 顶级生活刺激与精神狂欢：普通宠物的作息根本满足不了你天马行空的思维。癫菇会半夜两点拉着你在客厅打着手电筒跳机械舞，把每一次无聊的周末都过成一场秘密地下 Rave。',
      '3. 自由到超脱的生存哲学：它不被任何地球生物分类学定义，你也不需要被任何世俗标签定义。在这个压抑的世界里，你们两个是彼此心照不宣的合法精神病友。',
    ],
    metrics: [
      { label: '乐子人纯度指标', value: 100, note: '唯恐天下不乱笑对风浪', isWarning: true },
      { label: '精神状态超前纪元', value: 99, note: '彻底脱离常规认知轨道', isWarning: true },
      { label: '失控旋转狂暴动能', value: 96, note: '快乐孢子无差别扫射', isWarning: false },
      { label: '世俗规矩脱敏度', value: 98, note: '把一切严肃踩在脚下', isWarning: false },
    ],
    stampText: '【狂乱收容 · 准许发癫】',
    stampType: 'danger',
    coexistenceAdvice:
      '⚠️ 饲养警示：切勿在严肃长辈或教条领导面前展示它的旋转技能；室内建议配备迪斯科灯球与魔性音响；如果哪天你觉得自己快要被现实逼疯了，请立刻跟它一起倒立大笑三分钟。',
    confidentialLevel: 'CL-4 绝密级精神档案 · 极度高危乐子派',
  },

  belial: {
    subtitle: '终极反规则黑暗霸王 · 规则粉碎与混沌重构者',
    categoryBadge: '【极度高危：深渊级收容体】',
    badgeType: 'danger',
    systemVerdict:
      '系统综合鉴定：警报！受试者的心理剖面图在逆反（Rebellion）与失控（Chaos）维度均击穿了常规测量仪器的极限。你不是被动的摆烂者，你是一个胸怀烈火的规则粉碎者。你痛恨被安排、被规训、被定义，如果这趟列车开往你厌恶的方向，你宁可亲手把轨道炸掉，也绝不乖乖坐以待毙。\n\n「贝利亚」是深渊维度的黑暗霸王。它拥有睥睨一切的狂傲姿态与摧毁陈规陋习的毁灭性力量。它不会像温顺的宠物那样舔你的手，它会傲立在虚空之上，俯视着你，向你伸出利爪：“怎么，这无聊的世界，你想跟我一起重写规则吗？”',
    detailedAnalysis: [
      '1. 极致的反规则共鸣：当别人都在教你“成熟、妥协、忍耐”时，它在你耳边低语：“为什么要忍？把那些破规矩撕了！”它能瞬间点燃你胸中沉睡已久的叛逆野心，让你重掌人生的绝对主导权。',
      '2. 庞大高维能量注入：它狂暴的气场能为你撑开一个无人敢随意冒犯的精神结界。在它身旁，你将彻底告别讨好型人格与懦弱退让，获得一双傲视群雄的冷酷双眼。',
      '3. 宿命级的霸业同盟：你们的相遇不是饲养，而是一场跨越维度的黑暗契约签署。当现实的樊笼试图困死你时，它将化作你的铠甲与利刃，带你杀出一条属于自己的独立王道。',
    ],
    metrics: [
      { label: '规则粉碎与逆反值', value: 100, note: '极度危险 · 拒绝任何服从', isWarning: true },
      { label: '黑暗能量储备上限', value: 99, note: '庞大狂暴的深渊意志', isWarning: true },
      { label: '弱肉强食掌控欲望', value: 96, note: '不做羔羊只做主宰', isWarning: false },
      { label: '讨好型人格彻底清零', value: 0, note: '绝无半点妥协退让', isWarning: false },
    ],
    stampText: '【深渊封禁 · 契约共生】',
    stampType: 'danger',
    coexistenceAdvice:
      '⚠️ 饲养警示：严禁试图对其进行任何形式的驯化，那会触发其毁灭性反噬；以平视的霸王姿态与其结盟；当你感到无能为力时，唤醒它，它会借给你撕碎现实黑夜的力量。',
    confidentialLevel: 'CL-5 终极深红档案 · 非主宰级灵魂禁止靠近',
  },
};
